import {useMemo} from 'react';
import {AddToCartState} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/AddToCartService/constants';
import {useGlobals} from '../../../providers/globalPropsProvider';
import {StickyButtonAction} from '../../../constants';
import stylesParams from '../../../../components/ProductPage/stylesParams';

type TranslationFunction = (key: string) => string;

export function useStickyButtonText(t: TranslationFunction): string {
  const {currentPrice, labelOverrides, addToCartState, isUserInputsValid, styles} = useGlobals();
  const isBuyNow = styles.get(stylesParams.productPage_stickyButtonAction) === StickyButtonAction.BUY_NOW;

  return useMemo(() => {
    const isPreOrder = addToCartState === AddToCartState.PRE_ORDER;

    let baseText: string;
    switch (true) {
      case isBuyNow && isPreOrder:
        baseText = labelOverrides?.cta?.buyNow || t('productPage.preOrderNow.button');
        break;
      case isBuyNow:
        baseText = labelOverrides?.cta?.buyNow || t('BUY_NOW_BUTTON');
        break;
      case isPreOrder:
        baseText = labelOverrides?.cta?.addToCart || t('productPage.preOrder.button');
        break;
      default:
        baseText = labelOverrides?.cta?.addToCart || t('ADD_TO_CART_BUTTON');
        break;
    }

    return isUserInputsValid && currentPrice?.formattedActualPrice
      ? `${baseText} - ${currentPrice.formattedActualPrice}`
      : baseText;
  }, [
    addToCartState,
    t,
    isBuyNow,
    labelOverrides?.cta?.addToCart,
    labelOverrides?.cta?.buyNow,
    isUserInputsValid,
    currentPrice?.formattedActualPrice,
  ]);
}
